<template>
  <tr :class="index % 2 === 0 && `bg-grey-background-contrast`">
    <slot></slot>
  </tr>
</template>

<script lang="ts">
export default {
  name: 'FeatureTable',
  components: {},
  props: {
    index: {
      type: Number,
      required: true,
    },
  },
};
</script>
